import { render, staticRenderFns } from "./HistoryTickets.vue?vue&type=template&id=11cc96ca&scoped=true"
import script from "./HistoryTickets.vue?vue&type=script&lang=js"
export * from "./HistoryTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cc96ca",
  null
  
)

export default component.exports